"use client";

import { useState, type MouseEvent } from "react";

/**
 * "Continue with ClinicHub" — with a send-off. If the visitor played the
 * catch game (count read from the BloomField canvas's data-catches), the
 * button's label becomes "N dots caught. Now go catch the day." for a beat
 * before continuing to the WP bridge. Non-players and reduced-motion users
 * navigate instantly, as before.
 */
export function ClinicHubButton({ href }: { href: string }) {
  const [sendoff, setSendoff] = useState<string | null>(null);

  function onClick(e: MouseEvent<HTMLAnchorElement>) {
    if (sendoff) {
      // Already saying goodbye — swallow repeat clicks.
      e.preventDefault();
      return;
    }
    const canvas = document.querySelector<HTMLCanvasElement>(".lv2 canvas");
    const n = Number(canvas?.dataset.catches ?? "0");
    if (!n || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    e.preventDefault();
    setSendoff(`${n} dot${n === 1 ? "" : "s"} caught. Now go catch the day.`);
    window.setTimeout(() => {
      window.location.href = href;
    }, 1100);
  }

  return (
    <a className="lg-clinichub" href={href} onClick={onClick}>
      <span
        key={sendoff ?? "label"}
        className={`lg-clinichub-label${sendoff ? " lg-sendoff" : ""}`}
      >
        {sendoff ?? "Continue with ClinicHub"}
      </span>
      <span className="lg-clinichub-arrow" aria-hidden>
        &rarr;
      </span>
    </a>
  );
}
